'use client'
import { styled } from '../config'

export const Flex = styled('div', {
  display: 'flex',
})
